import { render, staticRenderFns } from "./BackAndSkip.vue?vue&type=template&id=1f478b45&"
import script from "./BackAndSkip.vue?vue&type=script&lang=js&"
export * from "./BackAndSkip.vue?vue&type=script&lang=js&"
import style0 from "./BackAndSkip.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports